export enum EmailFrequency {
  Never = 1,
  Daily = 2,
}